import React from 'react';

import {
  DefectCatalogItem,
  DefectSurveyYear,
  DefectSurveyYearSlug,
  DefectVisualizationRule,
} from 'domain/surveyDataManager/contracts';
import type { ActiveDefectLayerId } from 'state/surveyDataManager/activeLayersSlice';

import { isWizardSurveyYearFullyActive } from '../wizardLogic';

export interface WizardStepSurveyYearProps {
  readonly surveyYears: readonly DefectSurveyYear[];
  readonly defect: DefectCatalogItem | null;
  readonly measurement: DefectVisualizationRule | null;
  readonly activeLayerIds: ReadonlySet<ActiveDefectLayerId>;
  readonly selectedSurveyYearSlug: DefectSurveyYearSlug | null;
  readonly onSelectSurveyYear: (surveyYearSlug: DefectSurveyYearSlug) => void;
}

function WizardStepSurveyYear({
  surveyYears,
  defect,
  measurement,
  activeLayerIds,
  selectedSurveyYearSlug,
  onSelectSurveyYear,
}: WizardStepSurveyYearProps): JSX.Element {
  return (
    <div className="sdm-add-layer-wizard__panel">
      <h4 className="sdm-add-layer-wizard__panel-title">Choose survey year</h4>
      <div className="sdm-add-layer-wizard__card-grid sdm-add-layer-wizard__card-grid--years">
        {surveyYears.length === 0 ? (
          <p className="sdm-add-layer-wizard__hint" role="status">
            No survey years are available for this parameter.
          </p>
        ) : null}
        {surveyYears.map((year) => {
          const isSelected = selectedSurveyYearSlug === year.slug;
          const isDisabled =
            defect !== null &&
            measurement !== null &&
            isWizardSurveyYearFullyActive(activeLayerIds, defect, measurement, year);

          return (
            <button
              key={year.id}
              type="button"
              className={`sdm-add-layer-wizard__card sdm-add-layer-wizard__card--compact${
                isSelected ? ' sdm-add-layer-wizard__card--selected' : ''
              }${isDisabled ? ' sdm-add-layer-wizard__card--disabled' : ''}`}
              onClick={() => onSelectSurveyYear(year.slug)}
              disabled={isDisabled}
              aria-disabled={isDisabled || undefined}
              aria-pressed={isSelected}
            >
              <strong>
                {year.surveyYear}
                {isDisabled ? ' (active)' : ''}
              </strong>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default WizardStepSurveyYear;
